export default __webpack_public_path__ + "media/GOLD PACKAGE.8d7c70bf7c2dd0a113e0c50227c82568.mp4";